import { httpClient } from './api/httpClient';
import { isMockEnabled } from './api/mockAdapter';
import { API_ENDPOINTS } from 'constants/apiEndpoints';

export const toBriefingSchedule = (raw) =>
  raw && {
    numberOfBatches: raw.number_of_batches ?? 1,
    timeSlots: raw.time_slots ?? [],
    whatsappNumbers: raw.whatsapp_numbers ?? raw.whatsappNumbers ?? [],
    status: raw.status ?? 'inactive',
    updatedAt: raw.updated_at ?? raw.updatedAt ?? null,
    updatedBy: raw.updated_by ?? raw.updatedBy ?? null,
  };

const toPayload = (model) => ({
  number_of_batches: model.numberOfBatches,
  time_slots: model.timeSlots,
  whatsapp_numbers: model.whatsappNumbers,
  status: model.status ?? 'inactive',
});

let _mockSchedule = null;

export const briefingScheduleService = {
  async get() {
    if (isMockEnabled()) return _mockSchedule ? toBriefingSchedule(_mockSchedule) : null;
    const raw = await httpClient.get(API_ENDPOINTS.BRIEFING.SCHEDULE.GET);
    return raw ? toBriefingSchedule(raw) : null;
  },

  async upsert(model) {
    if (isMockEnabled()) {
      _mockSchedule = toPayload(model);
      return toBriefingSchedule(_mockSchedule);
    }
    const raw = await httpClient.put(API_ENDPOINTS.BRIEFING.SCHEDULE.PUT, toPayload(model));
    return toBriefingSchedule(raw);
  },
};

export default briefingScheduleService;
